import { render } from "./custFooter.vue?vue&type=template&id=4d814c8b&scoped=true"
import script from "./custFooter.vue?vue&type=script&lang=js"
export * from "./custFooter.vue?vue&type=script&lang=js"

import "./custFooter.vue?vue&type=style&index=0&id=4d814c8b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d814c8b"]])

export default __exports__